import React from 'react';
import { Card, CardMedia, useTheme } from '@mui/material';
import imgPlaceholder from '../../assets/images/recipe_placeholder_card.png';

const RecipePlaceholderCard = () => {
  const theme = useTheme();

  return (
    <Card
      style={{ backgroundColor: theme.palette.primary.loadingCardBackground }}
      sx={{
        width: 166,
        height: 260,
        minWidth: 166,
        borderRadius: '15px',
        margin: '6px',
        flexShrink: 0,
      }}>
      <CardMedia sx={{ height: 160 }} image={imgPlaceholder} />
    </Card>
  );
};

export default RecipePlaceholderCard;
